
class RelatedProducts extends HTMLElement {
  constructor() {
    super();
    new Swiper('.custom-products', {
      slidesPerView: 2,
      spaceBetween: 7,
      breakpoints: {
        750: {
          slidesPerView: 3.7,
          spaceBetween: 7,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next-related-products',
        prevEl: '.swiper-button-prev-related-products',
      },
    });
  }
}
customElements.define('related-products', RelatedProducts);
